<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none">
    <path
      d="M0.866667 11.0671C0.200001 10.5337 0.200001 9.46706 0.866667 8.93373L9.26667 0.933729C9.93333 0.267061 11 0.933727 11 2.00039L11 7.33373C11 7.33373 17.1333 7.06706 20.3333 7.33373C21.8 7.46706 23 8.53373 23 10.0004C23 11.4671 21.8 12.5337 20.3333 12.6671C17.2667 12.9337 11 12.6671 11 12.6671L11 18.0004C11 19.0671 9.93333 19.7337 9.13334 19.0671L0.866667 11.0671Z"
      fill="#212121"
    />
  </svg>
</template>
